// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"e8d99be7","416":"8435635c","754":"1efec64e"}[chunkId] + ".chunk.css";
};